module.exports = __webpack_public_path__ + "static/media/engagera-sig.fc81a817.mp3";